import en from "@/locales/fragments/staff-employees.en.json";
import ar from "@/locales/fragments/staff-employees.ar.json";
import prototypeEn from "@/locales/fragments/staff-prototype.en.json";
import prototypeAr from "@/locales/fragments/staff-prototype.ar.json";
import { staffFinishingText } from "@/components/staff/staff-finishing-language";

// Exact approved wording is extracted into the application's i18n fragments.
const translated = prototypeAr.staffPrototype as Record<string,string>;
const approved:Record<string,string>=Object.fromEntries(Object.entries(prototypeEn.staffPrototype).map(([key,source])=>[source,translated[key]]));
// Prefer the most specific approved template: "{0}d" must not consume
// "250 days unpaid" before the real unpaid-days sentence is considered.
const templates=Object.entries(approved).filter(([pattern])=>pattern.includes("{")).sort(([a],[b])=>b.replace(/\{\d+\}/g,"").length-a.replace(/\{\d+\}/g,"").length);
const months:Record<string,string>={Jan:"يناير",January:"يناير",Feb:"فبراير",February:"فبراير",Mar:"مارس",March:"مارس",Apr:"أبريل",April:"أبريل",May:"مايو",Jun:"يونيو",June:"يونيو",Jul:"يوليو",July:"يوليو",Aug:"أغسطس",August:"أغسطس",Sep:"سبتمبر",Sept:"سبتمبر",September:"سبتمبر",Oct:"أكتوبر",October:"أكتوبر",Nov:"نوفمبر",November:"نوفمبر",Dec:"ديسمبر",December:"ديسمبر"};
export function staffText(text:string,rtl:boolean):string {
  if(!rtl)return text;
  if(approved[text])return approved[text];
  const fragments=ar.staff as Record<string,string>;
  const english=en.staff as Record<string,string>;
  const key=Object.keys(english).find(key=>english[key]===text);
  if(key&&fragments[key])return fragments[key];
  const finishing=staffFinishingText(text);
  if(finishing)return finishing.replace(/\b[A-Za-z]+\b/g,word=>months[word]||word);
  const separators=[" · "," – ",": "];
  // Preserve approved full sentences before breaking operational labels into
  // fragments. Short suffix templates must not swallow untranslated sentences.
  for(const [pattern,translation] of templates.filter(([p])=>separators.some(s=>p.includes(s)))) {
    const escaped=pattern.replace(/[.*+?^${}()|[\]\\]/g,"\\$&").replace(/\\\{(\d+)\\\}/g,"(.+?)");
    const match=text.match(new RegExp(`^${escaped}$`));
    if(match)return translation.replace(/\{(\d+)\}/g,(_,n)=>{
      const captured=match[Number(n)+1]||"";
      return approved[captured]||staffFinishingText(captured)||captured.replace(/\b[A-Za-z]+\b/g,word=>months[word]||word);
    });
  }
  for(const sep of separators)if(text.includes(sep))return text.split(sep).map(part=>staffText(part,rtl)).join(sep);
  for(const [pattern,translation] of templates) {
    const escaped=pattern.replace(/[.*+?^${}()|[\]\\]/g,"\\$&").replace(/\\\{(\d+)\\\}/g,"(.+?)");
    const match=text.match(new RegExp(`^${escaped}$`));
     if(match&&!(pattern.replace(/\{\d+\}/g,"").length<=3&&match.slice(1).some(v=>/[A-Za-z]/.test(v))))return translation.replace(/\{(\d+)\}/g,(_,n)=>{
      const captured=match[Number(n)+1]||"";
       return approved[captured]||staffFinishingText(captured)||captured.replace(/\b[A-Za-z]+\b/g,word=>months[word]||word);
    });
  }
  return text;
}
